import { render, staticRenderFns } from "./ModRel.vue?vue&type=template&id=f70c1dba&scoped=true&"
import script from "./ModRel.vue?vue&type=script&lang=js&"
export * from "./ModRel.vue?vue&type=script&lang=js&"
import style0 from "./ModRel.vue?vue&type=style&index=0&id=f70c1dba&prod&scoped=true&lang=css&"
import style1 from "./ModRel.vue?vue&type=style&index=1&id=f70c1dba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70c1dba",
  null
  
)

export default component.exports